/* ============================================================
   sm-umsagnir.js
   Stjörnurnar og „N umsagnir“ efst á vörusíðunum skruna niður að
   umsögnunum (Judge.me). Án þessa gerði smellur á þær ekkert.
   Virkt aðeins þar sem umsagnahluti er á síðunni.
   ============================================================ */
(function () {
  function markmid() {
    return document.getElementById('judgeme_product_reviews') ||
           document.querySelector('.jdgm-review-widget');
  }

  function fara(e) {
    var m = markmid();
    if (!m) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    window.scrollTo({ top: m.getBoundingClientRect().top + window.scrollY - 16, behavior: 'smooth' });
  }

  function virkja() {
    if (!markmid()) return;
    document.querySelectorAll('.config-rating .jdgm-prev-badge').forEach(function (b) {
      if (b.hasAttribute('data-umsagnir')) return;
      b.setAttribute('data-umsagnir', '');
      b.setAttribute('role', 'link');
      b.setAttribute('tabindex', '0');
      b.setAttribute('aria-label', 'Sjá umsagnir');
      b.addEventListener('click', fara);
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') fara(e);
      });
    });
  }

  /* Judge.me birtir stjörnurnar og umsagnahlutann eftir hleðslu */
  function start() { [0, 1200, 4000].forEach(function (t) { setTimeout(virkja, t); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
